module.exports = __webpack_public_path__ + "img/Logo_Digiasia_Color.ef2bdf54.png";